<template>
  <div data-view="billing">
    <router-view/>

    <layout-logged-frame
      has-before
      :title="$t('accounts')"
      :total-count="pagination.totalItems"
    >
      <template v-slot:header-actions>
        <Can
          action="store"
          subject="loyalty_program"
        >
          <v-btn
            color="primary"
            @click="openNewAccountModal"
            data-cy="creator-program-add-new-account-button"
          >
            <v-icon>add</v-icon>
            {{ $t('add_new_account') }}
          </v-btn>
        </Can>
      </template>

      <template v-slot:content>
        <BillingFilters
          @filter="onFilter"
          @clearFilters="onClearFilters"
        />

        <BillingTable
          :items="billings"
          :pages="totalPages"
          :pagination="pagination"
          :is-loading="isLoading"
          :on-select-item="selectItem"
          :on-update-pagination="onUpdatePagination"
          :on-change-page="onChangePage"
        />
      </template>
    </layout-logged-frame>
  </div>
</template>

<script>
import BillingFilters from '../../components/forms/filters/Billing';
import { isStr, isNum, isObj } from '@/utils';
import columns from '../../config/billing/columns';
import BillingTable from '../../components/table/Billing';

export default {
  components: {
    BillingFilters,
    BillingTable
  },
  data() {
    return {
      columns,
      pagination: {
        order: 'desc' ,
        page: 1,
        rowsPerPage: 15,
        sortBy: 'updated_at',
        totalItems: 0,
        search: ''
      },
      totalPages: 0,
      query: {
        per_page: 15,
      },
      isLoading: false,
    };
  },
  computed: {
    billings() {
      return this.$store.getters['creatorProgram/billingAccounts'];
    },
    totalCount() {
      return this.pagination.totalItems || 0;
    },
    currentRoute() {
      return this.$route;
    },
  },
  watch: {
    currentRoute (to, from){
      if (
        (from.name === 'creator-program-billing-accounts-details' ||
          from.name === 'creator-program-billing-accounts-new') &&
        to.name === 'creator-program-billing-accounts' &&
        to.query?.status === 'success'
      ) {
        this.getItems(this.query);
      }
    }
  },
  created() {
    this.getCountries();
    this.getEuCountries();
  },
  methods: {
    getItems(query) {
      this.isLoading = true;
      this.pagination.order = query.order;

      return this.$store.dispatch('creatorProgram/getBillingAccounts', query)
        .then((res) => {
          const { billingAccountsMeta } = res;
          const { total, current_page, last_page } = billingAccountsMeta;

          this.pagination.page = current_page;
          this.pagination.totalItems = total;
          this.pagination.lastPage = last_page;
          this.totalPages = last_page;

          return res;
        })
        .catch((err) => err)
        .finally(() => {
          this.isLoading = false;
        });
    },
    selectItem(item) {
      this.$router.push({ name: 'creator-program-billing-accounts-details', params: { id: item.id } });

      return this.$store.dispatch('billing/setActiveItem', item);
    },
    onUpdatePagination({ page, order, sortBy }) {
      const { query, pagination } = this;
      this.pagination.order = order;
      this.pagination.sortBy = isStr(sortBy) ? sortBy : pagination.sortBy;

      const nextQuery = {
        ...query,
        page,
        order,
        sort: isStr(sortBy) ? sortBy : pagination.sortBy
      };

      this.query = nextQuery;
      this.getItems(nextQuery);
    },
    onChangePage(page) {
      const { query, pagination } = this;
      const { order, sortBy } = pagination;
      const nextQuery = {
        ...query,
        page,
        order,
        sort: sortBy
      };

      this.query = nextQuery;
      this.getItems(nextQuery);
    },
    onFilter(filters) {
      this.query = {
        ...this.query,
        page: 1,
        ...this.getSearchQuery(filters)
      };

      this.getItems(this.query);
    },
    onClearFilters() {
      const { sortBy } = this.pagination;
      this.query = {
        sort: sortBy,
        per_page: 15,
      };

      this.getItems(this.query);
    },
    getSearchQuery({ business, ...rest }) {
      const query = {...rest};

      query.business = isNum(business?.id) ? business.id : null;

      return query;
    },
    openNewAccountModal() {
      this.$router.push({ name: 'creator-program-billing-accounts-new' });
    },
    getCountries() {
      return this.$store.dispatch('config/getCountries');
    },
    getEuCountries() {
      return this.$store.dispatch('config/getEuCountries');
    },
  },
};
</script>

<style lang="scss">
@use '../../assets/styles/theme' as *;

[data-view="billing"] {
  .v-datatable {
    min-width: $table-min-width;
  }
}
</style>
